import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/framework/')({
  loader: () => {
    redirect({
      to: '/framework/search',
      throw: true,
    })
  },
  staticData: {
    breadcrumb: 'Framework',
  },
})
